import { ORG_GLOBAL_TOPIC } from '@/config/networkConstants';
import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { MessagePayload } from '@/types/poc/message';

interface PublishOrgGlobalMessageResult {
  messageType: MessagePayload['type'];
  timestamp: number;
  skipped: boolean;
}

export const publishOrgGlobalMessageThunk = createAppAsyncThunk<
  PublishOrgGlobalMessageResult,
  { message: MessagePayload }
>(
  'messaging/publishOrgGlobalMessage',
  async({ message }, { extra: { pocServices, loggerService }, rejectWithValue }) => {
    try {
      const activeSixId = pocServices.p2pStackManagerService
        .getAllSixIds()
        .find((sixId) => pocServices.p2pStackManagerService.getLibp2pNode(sixId) !== null);

      if (activeSixId === undefined) {
        loggerService
          .createLogger({ namespace: 'six3ro:p2p:messaging' })
          .warn(`Skipping org-global publish for '${message.type}' because no LibP2P node is available`);

        return {
          messageType: message.type,
          timestamp: Date.now(),
          skipped: true,
        };
      }

      const libp2pNode = pocServices.p2pStackManagerService.getLibp2pNode(activeSixId);
      if (libp2pNode === null) {
        throw new Error(`LibP2P node not ready for six '${activeSixId}'`);
      }

      await pocServices.messagingService.publishMessage(libp2pNode, ORG_GLOBAL_TOPIC, message);

      return {
        messageType: message.type,
        timestamp: Date.now(),
        skipped: false,
      };
    } catch (error) {
      const messageText = error instanceof Error ? error.message : String(error);
      return rejectWithValue({ message: messageText });
    }
  }
);
